import { render, staticRenderFns } from "./UpdateSalability.vue?vue&type=template&id=23fd4853&"
import script from "./UpdateSalability.vue?vue&type=script&lang=js&"
export * from "./UpdateSalability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports